import axios from 'axios';

export default async function ({ app: { $axios, store } }) {
    await store.dispatch('content/getDirectusSettings');
}
